<template>
  <div>
    <base-header class="pb-7 pt-7">
      <!-- Card stats -->
      <b-row>
        <b-col xl="3" md="6">
          <FacturacionSaldoTimbres />
        </b-col>
      </b-row>
    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--6">
      <b-row>
        <b-col>
          <!-- <div
            class="card card-flush shadow-sm mb-xl-8 animate__animated animate__fadeIn"
          >
            <div class="card-header border-0"></div>
          </div> -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import FacturacionSaldoTimbres from "./../../components/IDBRICS/FacturacionSaldoTimbres.vue";
export default {
  components: {
    FacturacionSaldoTimbres,
  },
  data() {
    return {
      working: false,
      error: [],
      saldo: {
        fechaExpiracion: null,
        saldoTimbres: -1392,
        timbresAsignados: 113280,
        timbresUtilizados: 12358301,
      },
    };
  },
  beforeMount() {
    this.saldoTimbres();
  },
  methods: {
    saldoTimbres() {
      this.working = true;

      this.$api
        .get("/facturacion/timbrado/saldo")
        .then((res) => {
          if (res.data.status == "success") {
            this.saldo = res.data.data;
          }
        })
        .catch((e) => this.error.push(e))
        .then(() => (this.working = false));
    },
  },
  filters: {
    formatNumberDecimal: function (value) {
      const options2 = {
        style: "decimal",
        currency: "USD",
        maximumFractionDigits: 2,
      };
      const numberFormat2 = new Intl.NumberFormat("en-US", options2);

      return numberFormat2.format(value);
    },
    formatNumberInteger: function (value) {
      const options2 = {
        style: "decimal",
        currency: "USD",
        maximumFractionDigits: 0,
      };
      const numberFormat2 = new Intl.NumberFormat("en-US", options2);

      return numberFormat2.format(value);
    },
  },
};
</script>
